import updateLoader from "./loaders";
import updateUser from "./user";
import updateEqueue from "./equeues";
import updatePanels from "./panels";
import updateSelectedEqueue from "./selectedEqueue";
import updateUserInfo from "./userInfo";
import updateRegionsAndMedicalOrganisations from "./regionAndOrganisation";
import updateDoctors from "./doctors";
import updateDates from "./dates";
import updateAlerts from "./alerts";
import updateSnils from "./snils";
import updateSnackbars from "./snackbars";
import updateOms from "./oms";
import updateMoscowScenario from "./moscowScenario";
import updateAddresses from "./addressess";

import {
  entry as vkEntry,
  SERVICE_PREFIX as vkServicePrefix,
} from '../../services/vk';


const reducer = (state, action) => {
  return {
    loader: updateLoader(state, action),
    user: updateUser(state, action),
    equeues: updateEqueue(state, action),
    panels: updatePanels(state, action),
    selectedEqueue: updateSelectedEqueue(state, action),
    userInfo: updateUserInfo(state, action),
    regionAndMedicalOrganisation: updateRegionsAndMedicalOrganisations(
      state,
      action
    ),
    doctors: updateDoctors(state, action),
    dates: updateDates(state, action),
    alerts: updateAlerts(state, action),
    snils: updateSnils(state, action),
    snackBars: updateSnackbars(state, action),
    oms: updateOms(state, action),
    moscowScenario: updateMoscowScenario(state, action),
    addresses: updateAddresses(state, action),
    [vkServicePrefix]: vkEntry.reducer(state?.[vkServicePrefix], action),
  };
};

export default reducer;
